import { CARD_TYPES, CardType } from '@21st-night/cards';
import { DeckContentItem } from '../../Deck.types';

export function isCard(item: DeckContentItem): boolean {
  return CARD_TYPES.includes(item.type as CardType);
}
